import React, { useState } from "react";
import { Create_Api } from "../../API_URL";
import { toast } from "react-toastify";

function RequestModel({ isOpen, onClose, Report }) {

    const [isUploading, setIsUploading] = useState(false);
    const [Name, setName] = useState('');
    const [Designation, setDesignation] = useState('');
    const [Organization, setOrganization] = useState('');
    const [Email, setEmail] = useState('');
    const [Why, setWhy] = useState('');
    const [errors, setErrors] = useState({});

    const validate = () => {
        const newErrors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!Name.trim()) newErrors.Name = "Name is required";
        if (!Designation.trim()) newErrors.Designation = "Designation is required";
        if (!Organization.trim()) newErrors.Organization = "Organization is required";
        if (!Email.trim()) newErrors.Email = "Email is required";
        else if (!emailRegex.test(Email.trim()))
            newErrors.Email = "Please enter a valid email address";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        try {
            setIsUploading(true);
            const data = {
                Name,
                Designation,
                Organization,
                Email,
                Why,
                Report
            };

            const response = await Create_Api("api/admin/CreateReportRequest", data);
            toast.success(response?.message || "Contact added successfully.");
            setName('');
            setEmail('')
            setOrganization('')
            setDesignation('')
            setWhy('')
            onClose()
        } catch (error) {
            toast.error(error?.response?.data?.message || "Error creating Category.");
            console.error("Error creating Category:", error);
        } finally {
            setIsUploading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center  z-[220] p-4">
            <div
                className="bg-white w-full max-w-[550px] rounded-[16px] sm:rounded-[24px] p-5 sm:p-8 relative overflow-y-auto max-h-[90vh]"
                style={{ boxShadow: "0px 10px 100px 0px #89A1A82B" }}
            >
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-xl sm:text-2xl"
                >
                    ✕
                </button>

                <h6 className="font-neue text-[20px] sm:text-[26px] md:text-[28px] leading-[28px] sm:leading-[36px] text-[#0F3460] pb-5">
                    {/* Send Signal for Report */}
                    Request Access
                </h6>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5 pb-6">
                    <div className="col-span-1 sm:col-span-2">
                        <input
                            value={Name}
                            onChange={(e) => setName(e.target.value)}
                            type="text"
                            className="font-neue text-[14px] sm:text-[15px] w-full py-3 px-4 rounded-[8px] border border-[#0922101A] text-[#092210B2]"
                            placeholder="Your Name *"
                        />
                        {errors?.Name && (
                            <p className="text-red-500 text-xs mt-1">{errors?.Name}</p>
                        )}
                    </div>

                    <div className="col-span-1 sm:col-span-2">
                        <input
                            value={Designation}
                            onChange={(e) => setDesignation(e.target.value)}
                            type="text"
                            className="font-neue text-[14px] sm:text-[15px] w-full py-3 px-4 rounded-[8px] border border-[#0922101A] text-[#092210B2]"
                            placeholder="Designation *"
                        />
                        {errors?.Designation && (
                            <p className="text-red-500 text-xs mt-1">{errors?.Designation}</p>
                        )}
                    </div>
                    <div className="col-span-1 sm:col-span-2">
                        <input
                            value={Organization}
                            onChange={(e) => setOrganization(e.target.value)}
                            type="text"
                            className="font-neue text-[14px] sm:text-[15px] w-full py-3 px-4 rounded-[8px] border border-[#0922101A] text-[#092210B2]"
                            placeholder="Organization *"
                        />
                        {errors?.Organization && (
                            <p className="text-red-500 text-xs mt-1">{errors?.Organization}</p>
                        )}
                    </div>

                    <div className="col-span-1 sm:col-span-2">
                        <input
                            value={Email}
                            onChange={(e) => setEmail(e.target.value)}
                            type="text"
                            className="font-neue text-[14px] sm:text-[15px] w-full py-3 px-4 rounded-[8px] border border-[#0922101A] text-[#092210B2]"
                            placeholder="Official Email"
                        />
                        {errors?.Email && (
                            <p className="text-red-500 text-xs mt-1">{errors?.Email}</p>
                        )}
                    </div>

                    <div className="col-span-1 sm:col-span-2">
                        <textarea
                            value={Why}
                            onChange={(e) => setWhy(e.target.value)}
                            rows={2}
                            className="font-neue text-[14px] sm:text-[15px] w-full py-3 px-4 rounded-[8px] border border-[#0922101A] text-[#092210B2]"
                            placeholder="Why You Want this Report"
                        ></textarea>
                    </div>
                </div>
                {/* <button
                    onClick={(e) => handleSubmit(e)}
                    style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }}
                    className="w-full py-3 sm:py-3.5 transition-all duration-500 hover:bg-transparent hover:text-[#BB872A] border hover:border-[#BB872A] border-[#FFFFFF] bg-[#BB872A] rounded-[8px] font-neue text-[14px] sm:text-[15px] text-center text-white"
                >
                    {isUploading ? "Please Wait..." : "Create Request"}
                </button> */}
                <button
                    onClick={(e) => handleSubmit(e)}
                    disabled={isUploading}
                    style={{ boxShadow: "0px 2px 16px 1px #FFFFFFB5 inset" }}
                    className={`w-full py-3 sm:py-3.5 transition-all duration-500 
    border border-[#FFFFFF] bg-[#BB872A] rounded-[8px] font-neue 
    text-[14px] sm:text-[15px] text-center text-white
    ${isUploading ? "opacity-50 cursor-not-allowed" : "hover:bg-transparent hover:text-[#BB872A] hover:border-[#BB872A]"}`}
                >
                    Create Request
                </button>
            </div>
        </div>

    );
}

export default RequestModel;
